import _ from "lodash";

import { DefaultCellFormatter } from "./dataGrid";

const convertMappingsToGridData = (gridData, mappings) => {
  const { headerRowIndex, lineItemDescriptionColumnIndex, dataSelectDirection, dataAnchorColumnIndex, doesIncludeTotalColumn, numExpectedPeriods } = mappings;
  const lastColIdx = dataSelectDirection === "ltr" ? dataAnchorColumnIndex + numExpectedPeriods : dataAnchorColumnIndex + 1;

  let colomnsFromHeaderRow = _.values(gridData[headerRowIndex - 1]);
  if (doesIncludeTotalColumn) {
    colomnsFromHeaderRow = colomnsFromHeaderRow.slice(0, lastColIdx);
  }

  const columnsForGrid = colomnsFromHeaderRow.map((val, idx) => ({
    key: idx.toString(),
    name: val,
    resizable: true,
    width: (idx === 0 || idx === lineItemDescriptionColumnIndex) ? 220 : 110,
    formatter: DefaultCellFormatter
  }));

  const rowsForGrid = gridData.slice(headerRowIndex).map((row, idx) => {
    const adjustedRow = {};
    _.values(row).forEach((val, index) => {
      let value;
      if (index === 1 && typeof val === "number") {
        value = val.toString();
      } else {
        value = typeof val === "string" ? val.trim() : val;
      }
      adjustedRow[index] = value;
    });

    if (doesIncludeTotalColumn) {
      delete adjustedRow[lastColIdx];
    }

    return {
      rowIndex: idx,
      row: adjustedRow
    };
  });


  return {
    rowsForGrid,
    columnsForGrid
  };
};

export default convertMappingsToGridData;
